import { TimeAgo } from '@/components/time-ago';
import { ColumnDef, createColumnHelper } from '@tanstack/react-table';
import { TFunction } from 'i18next';
import { UnifiedProfileTableItem } from '../types';

const columnHelper = createColumnHelper<UnifiedProfileTableItem>();

export const getUnifiedProfilesTableColumns = (t: TFunction) =>
  [
    columnHelper.accessor('email', {
      id: 'email',
      header: () => t('unifiedProfile:mail'),
      cell: ({ row }) => row.original.email,
      minSize: 550,
      maxSize: 550,
      meta: {
        className: () => 'font-medium',
      },
    }),
    columnHelper.accessor('datasources.type.name', {
      id: 'datasourceType',
      header: () => t('unifiedProfile:sourceType'),
      cell: ({ row }) => (row.original.datasources && row.original.datasources[0]?.type.name) || '--',
      minSize: 130,
      maxSize: 130,
    }),
    columnHelper.accessor('datasources.name', {
      id: 'datasourceName',
      header: () => t('unifiedProfile:sourceName'),
      cell: ({ row }) => (row.original.datasources && row.original.datasources[0]?.name) || '--',
      minSize: 150,
      maxSize: 150,
    }),
    columnHelper.accessor('createdAt', {
      id: 'createdAt',
      header: () => t('unifiedProfile:collectionDate'),
      cell: ({ getValue }) => {
        const firstValue = getValue()[0];

        return firstValue ? <TimeAgo time={firstValue} format='yyyy-MM-dd' /> : '--';
      },
      minSize: 150,
      maxSize: 150,
      meta: {
        className: () => 'text-tertiary-600',
      },
    }),
  ] as ColumnDef<UnifiedProfileTableItem>[];
